const swiper = new Swiper('.swiper-hero', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


  document.addEventListener('DOMContentLoaded', function() {
            const catalogList = document.getElementById('catalogList');
            const loadMoreBtn = document.querySelector('.catalog__link');
            const filterItems = document.querySelectorAll('.filter__item');
            
            let allData = []; 
            let filteredData = [];
            let currentFilter = 'all'; 
            let visibleCount = 3; 
            
            fetch('https://test.smarto.agency/smarto_complexes_list.json')
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Помилка завантаження даних');
                    }
                    return response.json();
                })
                .then(data => {
                    allData = data;
                    filteredData = [...allData];
                    renderCatalog();
                })
                .catch(error => {
                    catalogList.innerHTML = `<div class="error">${error.message}</div>`;
                    console.error('Помилка:', error);
                });
            
            function renderCatalog() {
                catalogList.innerHTML = '';
                
                const dataToShow = filteredData.slice(0, visibleCount);
                
                if (dataToShow.length === 0) {
                    catalogList.innerHTML = '<div class="no-results">Немає результатів за обраним фільтром</div>';
                    loadMoreBtn.style.display = 'none';
                    return;
                }
                
                dataToShow.forEach(item => {
                    const catalogItem = document.createElement('div');
                    catalogItem.className = 'item-catalog visible';
                    
                    catalogItem.innerHTML = `
                        <div class="item-catalog__head">
                            <div class="item-catalog__year">${item.year} р.</div>
                            <div class="item-catalog__type">${item.type}</div>
                        </div>
                        <div class="item-catalog__image">
                            <img src="${item.img}" alt="${item.name}">
                        </div>
                        <div class="item-catalog__title">${item.name}</div>
                        <div class="item-catalog__adress">${item.adress}</div>
                        <div class="item-catalog__subtitle">Переваги:</div>
                        <ul class="item-catalog_tags">
                            ${item.tags.map(tag => `<li>${tag}</li>`).join('')}
                        </ul>
                    `;
                    
                    catalogList.appendChild(catalogItem);
                });
                
                if (filteredData.length <= visibleCount) {
                    loadMoreBtn.style.display = 'none';
                } else {
                    loadMoreBtn.style.display = 'inline-flex';
                }
            }
            
            loadMoreBtn.addEventListener('click', function() {
                visibleCount += 3;
                renderCatalog();
            });
            
            filterItems.forEach(item => {
                item.addEventListener('click', function() {
                    filterItems.forEach(i => i.classList.remove('active'));
                    
                    this.classList.add('active');
                    
                    currentFilter = this.getAttribute('data-filter');
                    
                    if (currentFilter === 'all') {
                        filteredData = [...allData];
                    } else {
                        filteredData = allData.filter(item => item.type === currentFilter);
                    }
                    
                    visibleCount = 3;
                    
                    renderCatalog();
                });
            });
        });